import { render, staticRenderFns } from "./ValidationStatus.vue?vue&type=template&id=1fa81efd&"
import script from "./ValidationStatus.vue?vue&type=script&lang=ts&"
export * from "./ValidationStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports